export const BASICMODE = 'BASICMODE'

export const addBasicMode = data => (
    {
        type: BASICMODE,
        payload: data
    }
)
const initialstate = {
    basic_mode: {
        superficial_front_forearm: true,
    deep_front_forearm: true,
    superficial_back_forearm: true,
    deep_back_forearm: true,
    muscles_thumb: true,
    muscles_palm: true,
    deep_muscles_palm: true,
    },

}
const BasicModeReducer = (state = initialstate, action) => {
    switch (action.type) {
        case BASICMODE:
            return {
                ...state,
                basic_mode: action.payload
            }
        default:
            return state;
    }

}
export default BasicModeReducer;